import { useCallback, useRef, useTransition } from 'react';
import { RoleUserOrgAssociationDto } from '@/apiClient';
import { isAdminRole } from '@/lib/types';

export function useRoleRedirect(
  selectedOrganisationId: number | undefined,
  onRenderPublicSearchStateChange: (b: boolean) => void,
) {
  const redirectCalled = useRef(false);
  const [_, startTransition] = useTransition();

  return useCallback(
    (organisations: RoleUserOrgAssociationDto[], overrideRef = false) => {
      if (overrideRef || !redirectCalled.current) {
        redirectCalled.current = true;

        startTransition(() => {
          const selectedOrg = selectedOrganisationId
            ? organisations.find(
                (o) => o.organisationId === selectedOrganisationId,
              )
            : organisations[0];

          if (!isAdminRole(selectedOrg?.roleId)) {
            onRenderPublicSearchStateChange(true);
          }
        });
      }
    },
    [onRenderPublicSearchStateChange, selectedOrganisationId],
  );
}
